'use es6';

import Raven from 'raven-js';
export default (store => next => action => {
  next(action);
  Raven.setUser(store.getState());
});